import ActionTypes from '../constants/ActionTypes';
import api from '../constants/api';
import { authHeader } from '../helpers';
import { postApi } from '../helpers/http';

export const requestTerminals = () => ({
  type: ActionTypes.REQUEST_TERMINAL,
})

export const receiveTerminals = (json) => ({
  type: ActionTypes.RECEIVE_TERMINAL,
  items: json.data,
  receivedAt: Date.now()
})

const doFetchTerminals = params => async dispatch => {
  dispatch(requestTerminals());
  const data = {
        "process_type": "getDataPcList",
        "user_name": params.user_name,
        "section_name": params.section_name,
        "pc_name": params.pc_name,
        "department_name": params.department_name,
        "user_id": params.user_id,
        "department_id": params.department_id,
        "section_id": params.section_id,
        // "blnDiscardShow": params.blnDiscardShow,
        "mac_add": params.mac_add,
  };

  try {
    const json = await postApi(data);
    dispatch(receiveTerminals(json));
  } catch (error) {
    console.error('Error:', error);
  };
  
  // console.log('fetch:', data);
  // return fetch(api.url, {
  //   method: 'POST',
  //   headers: authHeader(),
  //   body: JSON.stringify(data),
  // })
  // .then(response => response.json())
  // .then(json => {
  //   // console.log('Success:', json);
  //   dispatch(receiveTerminals(json))
  // })
  // .catch((error) => {
  //   console.error('Error:', error);
  // });
}

export const fetchTerminals = params => (dispatch, getState) => {
  return dispatch(doFetchTerminals(params));
}
